import type {ReactElement} from 'react';
import type {SeasonalBrandkitPopoverProps} from './seasonal-brandkit-popover.types';
import {SeasonPopup} from '@Components/season-popup/season-popup';
import {isMobileScreenWidth} from '@Utils/dom.util';
import {PopoverDefaultAlignment} from '@Components/popover/popover.types';
import {getAssetUrl} from '@Utils/s3.util';
import {getImageFilenameForSeasonalBrandkitPopover, getTextForSeasonalBrandkitPopover} from '@Libraries/seasonal-brandkit-popover.library';
import {getCompatibleImageFileExtension} from '@Utils/image.util';
import {getCurrentSeasonName} from '@Libraries/seasons.library';
import {useShowSeasonalBrandkitPopover} from '@Hooks/brands/useShowSeasonalBrandkitPopover';

export function SeasonalBrandkitPopover({...props}: SeasonalBrandkitPopoverProps): ReactElement<any> | null {
  const currentSeasonName = getCurrentSeasonName();
  const [showSeasonalBrandkitPopover] = useShowSeasonalBrandkitPopover(currentSeasonName);

  if (!currentSeasonName) {
    return null;
  }

  if (!showSeasonalBrandkitPopover) {
    return null;
  }

  return (
    <SeasonPopup
      onClose={() => {
        props.onMarkAsSeen();
      }}
      doCloseOnOuterClick={false}
      isPositionFixed
      referenceElement={props.referenceElement}
      arrowAlignment={isMobileScreenWidth() ? PopoverDefaultAlignment.BOTTOM_START : PopoverDefaultAlignment.RIGHT_START}
      imageUrl={getAssetUrl(`${getImageFilenameForSeasonalBrandkitPopover(currentSeasonName)}.${getCompatibleImageFileExtension('webp')}`)}
      title={getTextForSeasonalBrandkitPopover(currentSeasonName)}
    />
  );
}
